var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "items color" }, [
    _c(
      "ul",
      {
        staticClass: "d-flex flex-wrap list-unstyled mb-0",
        attrs: { id: "sizeList" },
      },
      _vm._l(_vm.variationsToShow, function (variation) {
        return _c("li", { key: variation.variationId }, [
          _c(
            "a",
            {
              class: {
                sold: !variation.hasStock,
                active: _vm.variationId === variation.variationId,
              },
              attrs: { href: _vm.langPrefix + variation.urlPath },
            },
            [_vm._v("\n        " + _vm._s(variation.name) + "\n      ")]
          ),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }